import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import { generateSicarCaptcha } from "../../../../api";
import Skeleton from "../../../../components/Skeleton";
import "./styles.scss";

const CaptchaModal = ({ onClose, onError, onSend }) => {
  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [session, setSession] = useState(null);
  const [captchaSolution, setCaptchaSolution] = useState("");

  useEffect(() => {
    setIsLoading(true);

    generateSicarCaptcha()
      .then(res => {
        const { data } = res;

        setImage(data.image);
        setSession(data.session);

        setIsLoading(false);
      })
      .catch(error => {
        const message =
          "Houve uma falha ao carregar o Captcha, pois o sistema do SICAR está fora do ar. Por favor tente mais tarde.";
        onError(message);

        console.error("Error during getting captcha from SICAR:", error);
      });
  }, [onError]);

  function onClickHandler() {
    setIsLoading(true);

    onSend({
      session,
      captcha: captchaSolution
    });
  }

  return (
    <>
      <div className="modal captcha-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "resolver-captcha" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <div className="modal-card-body">
            {!isLoading || captchaSolution.length !== 0 ? (
              <>
                <img src={`data:image/png;base64,${image}`} alt="Captcha" />

                <input
                  className="input"
                  id="captcha"
                  type="text"
                  onChange={e => setCaptchaSolution(e.target.value)}
                  value={captchaSolution}
                />
              </>
            ) : (
              <Skeleton width="100%" />
            )}
          </div>
          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              onClick={onClickHandler}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default CaptchaModal;
